// extracted by mini-css-extract-plugin
module.exports = {"view-modal":"ViewModal_view-modal__LaZQM"};